const ERROR_MESSAGES: Record<string, string> = {
  "Individual already exists with this ufu name":
    "Já existe um indivíduo com esse nome UFU.",
  "Individual does not exist": "Indivíduo não encontrado.",
  "Individual needs to be able to be release": "Indivíduo precisa ser solto.",
  "Taxonomic group already exists": "Grupo taxonômico já existe.",
  "Taxonomic group does not exists": "Grupo taxonômico não encontrado.",
  "User already exists with this email":
    "Já existe um usuário com este e-mail.",
  "User does not exists": "Usuário não encontrado.",
  "User is disabled":
    "Usuário está bloqueado. Entre em contato com o administrador.",
  "Credentials are not valid.": "Credenciais inválidas.",
  "Created date filters and released date filters cannot be used together":
    "Filtros de data de criação e data de soltura não podem ser usados juntos.",
  "Invalid register combination": "Combinação de registro inválida.",
  "Invalid sample combination": "Combinação de amostra inválida.",
  "Individual does not have a collar assigned":
    "Indivíduo não possui rastreador atribuído.",
};

export default ERROR_MESSAGES;
